package io.horion.cv.components.forms


import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.remember
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.framework.annotations.DelicateApi
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import io.horion.cv.components.cards.GenericFormCardNew
import io.horion.cv.components.cards.SummaryData
import io.horion.cv.components.dynamicfields.DynamicAddForm
import io.horion.cv.components.widgets.AjouterBoutton
import io.horion.cv.di.koinGet
import io.horion.cv.models.Job
import io.horion.cv.models.Requierement
import io.horion.cv.utils.Colors
import io.horion.cv.viewModel.JobViewModel
import org.jetbrains.compose.web.css.px



@OptIn(DelicateApi::class)
@Composable
fun RequierementContent() {
    val jobViewModel = koinGet<JobViewModel>()
    val jobUiState = jobViewModel.jobUiState
    val requierementFromVM = jobUiState.currentJob.requirements
    val breakpoint = rememberBreakpoint()

    LaunchedEffect(Unit) {
        if (requierementFromVM.isEmpty()) {
            jobViewModel.updateRequirement(0, "")
            jobViewModel.editingRequirement = "requierement-0"
        }
    }

    Column(
        verticalArrangement = Arrangement.spacedBy(30.px)
    ) {
        requierementFromVM.forEachIndexed { index, requierement ->
            val tempId = "requierement-$index"

            val requierementObj = remember(requierement) {
                Requierement(id = tempId, requierement = requierement)
            }

            GenericFormCardNew(
                item = requierementObj,
                isEditing = jobViewModel.editingRequirement == tempId,
                onEdit = { jobViewModel.editingRequirement = tempId },
                onDelete = {
                    jobViewModel.deleteRequirement(index)
                    if (jobViewModel.jobUiState.currentJob.requirements.isEmpty()) {
                        jobViewModel.updateRequirement(0, "")
                        jobViewModel.editingRequirement = "Requierement-0"
                    } else {
                        jobViewModel.editingRequirement = null
                    }
                },
                onComplete = { jobViewModel.editingRequirement = null },
                getSummary = { rq ->
                    if (rq.requierement.isNotBlank()) {
                        SummaryData(title = rq.requierement, subtitle = "")
                    } else null
                },
                getDefaultText = { "[Requierement ]" },
                formContent = { s, onDel, onComp ->
                    DynamicAddForm(
                        index = index,
                        onDelete = onDel,
                        onComplete = onComp,
                        label = "Requierement",
                        value = requierement,
                        onValueChange = { req ->
                            jobViewModel.updateRequirement(index,req) }
                    )
                },
                isMobile = breakpoint <= Breakpoint.MD,
                isTablet = breakpoint >= Breakpoint.SM && breakpoint < Breakpoint.MD
            )
        }


        AjouterBoutton(
            text = "Ajouter une requierement ",
            onClick = {
                val nextIndex = requierementFromVM.size
                jobViewModel.updateRequirement(nextIndex, "")
                jobViewModel.editingRequirement = "requirement-$nextIndex"
            },
            isMobile = breakpoint < Breakpoint.SM,
            isTablet = breakpoint >= Breakpoint.SM && breakpoint < Breakpoint.MD,
            color = Colors.black
        )
    }
}